module.exports = __webpack_public_path__ + "static/media/11.cade8f60.jpg";